import type { Story } from '@shared/api/types/story';
import { ACTION_TYPES, STATUS_TYPES } from '@shared/api/types/story';

export const magicstoreTonpunks: Story = {
  id: 'magicstore-tonpunks',
  type: 'SOQUEST',
  status: STATUS_TYPES.ACTIVE,
  name: 'Magic Store tonpunks',
  index: 0,
  content: {
    type: ACTION_TYPES.SOQUEST,
    metadata: {
      title: 'Magic Store Campaign: Earn 15,000 $SHIB in the TonPunks Campaign',
      description:
        'Join the web3 world at Magic Store by Magic Square. Earn 15,000 $SHIB by completing the Ton Punks Campaign',
      keywords:
        'Web3, Crypto, Hot Offer, Magic Store, Magic Square, Ton Punks Campaign, SHIB, Web3 App Store, Decentralized Apps, Crypto Rewards, TonPunks, DApps, Win Crypto, Digital Assets, Web3 Technology',
    },
    config: {
      key: 'e136f83d9b47e631b5ce53e5e03015981cfd',
      scode: 'MagicSquare',
      ccode: 'orqNNzblit',
    },
  },
};
